export default {
  customerServiceRatings: [],
  customerServiceRating: undefined,
};
